export default __webpack_public_path__ + "static/media/express.7c2432e8.svg";